module.exports = __webpack_public_path__ + "img/item-4.4a47af7.svg";